import { Button, Flex, Icon, Icons, type TableColumnType } from "@ir/ui";
import {
  MasterDataRawRetailerAssociation,
  type IMasterDataRawRetailerAssociation,
  type MasterDataRawRetailerAssociation as MasterDataRawRetailerAssociationEntity,
} from "@src/domain/entities/masterData";
import { Permissions } from "@src/domain/permissions";
import HasAnyPermission from "@src/presentation/components/permissions/HasAnyPermission";
import { MASTER_DATA_COLUMN_VERTICAL_ALIGN } from "./masterDataTable.shared";

export interface MasterDataRawRetailerAssociationRow
  extends IMasterDataRawRetailerAssociation {
  key: string;
}

export function mapRawAssociationsToRows(
  associations: MasterDataRawRetailerAssociationEntity[],
): MasterDataRawRetailerAssociationRow[] {
  return associations.map((entity) => ({
    ...MasterDataRawRetailerAssociation.toJSON(entity),
    key: String(entity.rawRetailerId),
  }));
}

export function indexRawAssociationsById(
  associations: MasterDataRawRetailerAssociationEntity[],
): Map<number, MasterDataRawRetailerAssociationEntity> {
  const map = new Map<number, MasterDataRawRetailerAssociationEntity>();
  for (const association of associations) {
    map.set(association.rawRetailerId, association);
  }
  return map;
}

export function buildRawAssociationActionsColumn(
  onEdit: (entity: MasterDataRawRetailerAssociationEntity) => void,
  associationsById: Map<number, MasterDataRawRetailerAssociationEntity>,
): TableColumnType<MasterDataRawRetailerAssociationRow> {
  return {
    title: "Actions",
    dataIndex: "rawRetailerId",
    key: "actions",
    align: "center",
    fixed: "right",
    verticalAlign: MASTER_DATA_COLUMN_VERTICAL_ALIGN,
    width: 80,
    cellRender: (value: unknown) => {
      const id = Number(value);
      const association = associationsById.get(id);
      if (!association) return null;
      return (
        <HasAnyPermission requiredPermissions={[Permissions.MASTER_DATA_EDIT]}>
          <Flex align="center" justifyContent="center">
            <Button
              size="small"
              variant="outline"
              color="grey"
              aria-label={`Edit ${association.rawRetailerName}`}
              onPress={() => onEdit(association)}
            >
              <Icon name={Icons.Edit} size="small" />
            </Button>
          </Flex>
        </HasAnyPermission>
      );
    },
  };
}
